// extracted by mini-css-extract-plugin
export default {"titlePage":"feature_titlePage__C5xC9"};